import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { getScrollTop, scrollTo } from '@theme/scroll-container';

/** Changes only the product section; the editorial content and scroll position stay put. */
class StylrikCollectionNav extends Component {
  #request = 0;
  #sectionId;

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#request++;
    if (this.#sectionId) sectionRenderer.abortRender(this.#sectionId);
  }

  /** @param {MouseEvent} event */
  async selectCollection(event) {
    const link = event.target.closest('a');
    const results = document.querySelector('collection-component results-list');
    const sectionId = results?.getAttribute('section-id');
    if (!link || !sectionId || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    const request = ++this.#request;
    let scrollTop = getScrollTop();
    this.#sectionId = sectionId;
    const current = new URL(location.href);
    for (const key of ['sort_by', 'preview_theme_id']) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    const section = document.getElementById(`shopify-section-${sectionId}`);
    section?.setAttribute('aria-busy', 'true');
    this.refs.status.textContent = '';
    try {
      await sectionRenderer.renderSection(sectionId, {
        url: new URL(url),
        injectStylesheet: true,
        shouldRender: html => {
          if (request !== this.#request || !this.isConnected) return false;
          if (!html.includes(`id="shopify-section-${sectionId}"`)) throw new Error('Missing collection section');
          scrollTop = getScrollTop();
          return true;
        },
      });
      if (request !== this.#request || !this.isConnected) return;
      scrollTo({ top: scrollTop, behavior: 'instant' });
      // Keep native sorting/pagination on the selected collection without navigating.
      history.replaceState(history.state, '', url);
      for (const item of this.querySelectorAll('nav a')) {
        if (item === link) item.setAttribute('aria-current', 'page');
        else item.removeAttribute('aria-current');
      }
      this.refs.status.textContent = link.textContent.trim();
    } catch {
      if (request === this.#request) this.refs.status.textContent = this.dataset.error;
    } finally {
      if (request === this.#request) document.getElementById(`shopify-section-${sectionId}`)?.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('stylrik-collection-nav')) customElements.define('stylrik-collection-nav', StylrikCollectionNav);
